import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolders32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFolders32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M15.395 4a3 3 0 0 1 2.496 1.336L19.667 8H24a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4v1a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V12a3 3 0 0 1 3-3h1V7a3 3 0 0 1 3-3zM6 24a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H6zm7.629-14q.141.158.262.336L15.667 13H20a4 4 0 0 1 4 4v4a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2zM7 11a1 1 0 0 0-1 1v1h7.263l-1.036-1.555a1 1 0 0 0-.832-.445zm4-5a1 1 0 0 0-1 1v1h7.263l-1.036-1.555A1 1 0 0 0 15.395 6z"
            />
        </svg>
    );
}
export default memo(IconFolders32);
